import { type LocalPhotoRef, PHOTO_CONTEXTS } from '@/shared/capture/capture-session';

export function createLlmPhotoRef(photo: LocalPhotoRef, index: number) {
  if (photo.context === PHOTO_CONTEXTS.register) {
    return photo.registerId ?? `register-${index + 1}`;
  }

  return `${photo.context}-${index + 1}`;
}

export function readLlmPhotoFieldName(photo: LocalPhotoRef) {
  return photo.context === PHOTO_CONTEXTS.register ? 'files.registers' : 'files.photos';
}
